var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7C4 6.73479 4.10536 6.48043 4.29289 6.2929C4.48043 6.10536 4.73478 6 5 6H12C12.1314 5.99977 12.2616 6.02543 12.3831 6.07554C12.5045 6.12564 12.615 6.1992 12.708 6.292L15.414 9H27C27.2652 9 27.5196 9.10536 27.7071 9.2929C27.8946 9.48043 28 9.73478 28 10V25C28 25.2652 27.8946 25.5196 27.7071 25.7071C27.5196 25.8946 27.2652 26 27 26H5C4.73478 26 4.48043 25.8946 4.29289 25.7071C4.10536 25.5196 4 25.2652 4 25V7ZM6 8V13H26V11H15C14.8686 11.0002 14.7384 10.9746 14.6169 10.9245C14.4955 10.8744 14.385 10.8008 14.292 10.708L11.586 8H6Z",
    fill: "#7692FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projects-icon.f8adae36e92be63d7ce122ed0e6f1d34.svg";
export { ForwardRef as ReactComponent };